export const defaultCollections = [
  {
    name: 'Nas Academy x Curious Addys Zombie Edition',
    collectionSlug: 'nas-academy-x-curious-addys-zombie-edition',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/Burux_pLV8AVHhd5dqLUXSFNJgs8AJb_b1kx4lMVug78StmQfVArJzQEL_FUWWGIjuFMTg0o8X_LoDQNt6YWSjQPmI_Esm_76Y_QNg=s130',
  },
  {
    name: "Curious Addys' Trading Club",
    collectionSlug: 'catc',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/-T-XoQR_VZwTi0WM4MNXyWO6iHpa4xTu1ISfgMZCq5K-W4UD6hxxIETNXXdxyrsGaMzG0ioZy3G1pjKR4ZccCNUcd_osE5dGNy5ong=s130',
  },
  {
    name: 'Women and Weapons',
    collectionSlug: 'womenandweapons',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/V7zthClFFknAFy3-ts8yXvqTQ7oRXmS9huaGjtquVRqAUrnwngJ0_JoJfhMDhwxl_pPdP20ncjE5RW5wtBZMDHJ8_xLNBzndTTqhTA=s130',
  },
  {
    name: 'Meta Angels NFT',
    collectionSlug: 'metaangelsnft',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/J4sUEAJDbvc-6bgkHQyNtQRxlFr1CkZZ1d14DSGR1x7miJZN0AXcV81Hlc9yQEx3XkyAnvbeFukFQlODyNDjwBcIvHOsh7eeYTIQnWs=s130',
  },
  {
    name: 'WomenRise',
    collectionSlug: 'womenrise',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/2MsWeFGP4TzS3LiwOTQ4NnmGWvA-cWCcTng-R_ZCve_fYvqJ8slusr-f7y8Q0adO2QrpPWMjD6TadLRrbHfrbrzVGWPSWBLVs-zPGA=s130',
  },
  {
    name: 'MavionWorld',
    collectionSlug: 'mavionworld',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/2tVx9GS7KRIPXrsjE4kKa8NWFqblP0f-S0pwD7m3rB4J6XKPC4jz5qhcohXI8yfsuySIO6KBs3D8Sy0tD2qvYkmhAlpJu9q8wfkO=s130',
  },
  {
    name: '90s Babes NFT | BABE',
    collectionSlug: '90s-babesnft',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/mijSwof-ktlumGbicaGR-KgcHsi3xjEm9DsxD6Fq2Iph_l9QnTaVj6TvCzPw5M-RoBp8LYFrNT0648oYhVG2Goiw86gwYiwlCYYFt5g=s130',
  },
  {
    name: 'Bored Ape Yacht Club',
    collectionSlug: 'boredapeyachtclub',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/Ju9CkWtV-1Okvf45wo8UctR-M9He2PjILP0oOvxE89AyiPPGtrR3gysu1Zgy0hjd2xKIgjJJtWIc0ybj4Vd7wv8t3pxDGHoJBzDB=s130',
  },
  {
    name: 'Boss Beauties',
    collectionSlug: 'bossbeauties',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/pSvJC9PfgSxXROesWTc2SACmMT598Vuv0g5kURR7o-0wkdhkRQKIw__fghIs-zhL-Ja-qOzI7_twdyglU75FOIksxpuuEhh4-fVDEK8=s130',
  },
  {
    name: 'CryptoPunks',
    collectionSlug: 'cryptopunks',
    isNew: false,
    img:
      'https://lh3.googleusercontent.com/BdxvLseXcfl57BiuQcQYdJ64v-aI8din7WPk0Pgo3qQFhAUH-B6i-dCqqc_mCkRIzULmwzwecnohLhrcH8A9mpWIZqA7ygc52Sr81hE=s130',
  },
  {
    name: 'Crypto Coven',
    collectionSlug: 'cryptocoven',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/E8MVasG7noxC0Fa_duhnexc2xze1PzT1jzyeaHsytOC4722C2Zeo7EhUR8-T6mSem9-4XE5ylrCtoAsceZ_lXez_kTaMufV5pfLc3Fk=s130',
  },
  {
    name: 'Doodles',
    collectionSlug: 'doodles-official',
    isNew: true,
    img:
      'https://lh3.googleusercontent.com/7B0qai02OdHA8P_EOVK672qUliyjQdQDGNrACxs7WnTgZAkJa_wWURnIFKeOh5VTf8cfTqW3wQpozGedaC9mteKphEOtztls02RlWQ=s130',
  },
];

export const nftList = {
  ownedNfts: [
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000009',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'Master NFTs in 7 days',
      description: 'Certificate for mark for graduating course Grab (Class 1)',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/9.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/9.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel (1).jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel (1).jpeg',
        },
      ],
      metadata: {
        name: 'mark',
        description:
          'Certificate for mark for graduating course Grab (Class 1)',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel (1).jpeg',
        attributes: [
          {
            classNumber: '1',
            createdAt: '2022-02-18T05:32:24.832Z',
            courseName: 'Grab',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.033Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000005',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName',
      description:
        'Certificate for testDisplayName for graduating testCourseName',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/5.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/5.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName',
        description:
          'Certificate for testDisplayName for graduating testCourseName',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T09:35:35.338Z',
            courseName: 'testCourseName',
            courseCode: 'testcourse1',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.246Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000006',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName',
      description:
        'Certificate for testDisplayName for graduating testCourseName',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/6.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/6.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName',
        description:
          'Certificate for testDisplayName for graduating testCourseName',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T09:40:39.916Z',
            courseName: 'testCourseName',
            courseCode: 'testcourse1',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.188Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000007',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName',
      description:
        'Certificate for testDisplayName for graduating testCourseName',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/7.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/7.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName',
        description:
          'Certificate for testDisplayName for graduating testCourseName',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel2.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T09:49:41.782Z',
            courseName: 'testCourseName',
            courseCode: 'testcourse1',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:53.431Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000008',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName8',
      description: 'Certificate for testDisplayName8 for graduating MarkCourse',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/8.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/8.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName8',
        description:
          'Certificate for testDisplayName8 for graduating MarkCourse',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T11:44:29.742Z',
            courseName: 'MarkCourse',
            courseCode: 'MarkCourseCode',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.212Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000001',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'Mark Course',
      description: 'Certificate for Mark Course for graduating NFT by Benu',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/1.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/1.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        },
      ],
      metadata: {
        name: 'Mark Course',
        description: 'Certificate for Mark Course for graduating NFT by Benu',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        attributes: [
          {
            createdAt: '2022-02-18T09:40:13.289Z',
            courseName: 'NFT by Benu',
            courseCode: 'NFTCourse',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.078Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x000000000000000000000000000000000000000000000000000000000000000a',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'Benu Yu Crypto',
      description: '',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/10.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/10.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        },
      ],
      metadata: {
        name: 'Benu Yu Crypto',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        attributes: {
          courseName: 'Ben Yu Cryto Course',
          graduationDate: '10-Feb-2022',
          classNumber: '007',
          displayName: 'Benu Yu Crypto',
        },
      },
      timeLastUpdated: '2022-02-24T02:18:54.104Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000002',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName',
      description:
        'Certificate for testDisplayName for graduating testCourseName',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/2.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/2.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName',
        description:
          'Certificate for testDisplayName for graduating testCourseName',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T07:38:10.135Z',
            courseName: 'testCourseName',
            courseCode: 'testcourse1',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.198Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x000000000000000000000000000000000000000000000000000000000000000b',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'Benu Yu Crypto',
      description:
        'Certificate for Benu Yu Crypto for graduating course Ben Yu Cryto Course (Class 007)',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/11.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/11.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        },
      ],
      metadata: {
        name: 'Benu Yu Crypto',
        description:
          'Certificate for Benu Yu Crypto for graduating course Ben Yu Cryto Course (Class 007)',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        attributes: {
          courseName: 'Ben Yu Cryto Course',
          graduationDate: '10-Feb-2022',
          classNumber: '007',
          displayName: 'Benu Yu Crypto',
        },
      },
      timeLastUpdated: '2022-02-24T02:17:10.872Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000003',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'NFT Course Test',
      description: 'Certificate for NFT Course Test for graduating NFT by Benu',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/3.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/3.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        },
      ],
      metadata: {
        name: 'NFT Course Test',
        description:
          'Certificate for NFT Course Test for graduating NFT by Benu',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/benu.jpeg',
        attributes: [
          {
            createdAt: '2022-02-21T09:46:40.721Z',
            courseName: 'NFT by Benu',
            courseCode: 'NFT Course',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.179Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x000000000000000000000000000000000000000000000000000000000000000c',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'Benu Yu Crypto',
      description:
        'Certificate for Benu Yu Crypto for graduating course Ben Yu Cryto Course (Class 007)',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/12.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/12.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        },
      ],
      metadata: {
        name: 'Benu Yu Crypto',
        description:
          'Certificate for Benu Yu Crypto for graduating course Ben Yu Cryto Course (Class 007)',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
        attributes: {
          courseName: 'Ben Yu Cryto Course',
          graduationDate: '10-Feb-2022',
          classNumber: '007',
          displayName: 'Benu Yu Crypto',
        },
      },
      timeLastUpdated: '2022-02-24T02:18:54.079Z',
    },
    {
      contract: {
        address: '0x1cf81426cf69c1900bc6c384443b8e2d23a239e1',
      },
      id: {
        tokenId:
          '0x0000000000000000000000000000000000000000000000000000000000000004',
        tokenMetadata: {
          tokenType: 'ERC721',
        },
      },
      title: 'testDisplayName',
      description:
        'Certificate for testDisplayName for graduating testCourseName',
      tokenUri: {
        raw:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/4.json',
        gateway:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_METADATA/4.json',
      },
      media: [
        {
          raw:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
          gateway:
            'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
        },
      ],
      metadata: {
        name: 'testDisplayName',
        description:
          'Certificate for testDisplayName for graduating testCourseName',
        image:
          'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/cheezel1.jpeg',
        attributes: [
          {
            createdAt: '2022-02-17T09:34:28.801Z',
            courseName: 'testCourseName',
            courseCode: 'testcourse1',
          },
        ],
      },
      timeLastUpdated: '2022-02-24T02:18:54.183Z',
    },
  ],
  totalCount: 12,
  blockHash:
    '0xed31d076a00f2962a5941daa14927ae6e0bcf4bd28e19d2f266b76ff2c9964e7',
};
